// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed237bac","284":"4792186b","453":"8d8e1995","626":"4feb9852","651":"ed4ac699","732":"cfe67d3e"}[chunkId] + ".chunk.js";
};